import { Box, Stack, Text } from '@chakra-ui/react'
import * as React from 'react'

interface SubNavGroupProps {
  children: React.ReactNode
}

export const SubNavGroup = (props: SubNavGroupProps) => {
  const { children } = props
  return (
    <Box pl="3">
      <Stack spacing="1">{children}</Stack>
    </Box>
  )
}
